import { FC, useCallback, useMemo } from 'react'
import { StreamControlPreset, CONTROL_ON, CONTROL_OFF } from 'components/features/coaching/advisorVideoCall/StreamControlPreset/StreamControlPreset'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { AgoraScreenShareAction, AgoraStopScreenShareAction, AgoraScreenShareUnavailableAction } from 'components/features/videoCalls/types/actions'
import { createStream } from 'agora-rtc-sdk'
import { IS_FIREFOX } from 'helpers/userAgentHelpers'


type ScreenShareControlProps = {
  isFullScreen: boolean
}
export const ScreenShareControl: FC<ScreenShareControlProps> = (props) => {
  const { isFullScreen } = props
  const streamId = useStoreSelector((state) => state.data.advisors.videoCallDetails.details?.video?.connection?.screen_share_uid || null)
  const shareScreenState = useStoreSelector((state) => state.app.videoCall.screenStream.state)
  const isAvailable = useStoreSelector((state) => state.app.videoCall.screenStream.isAvailable)

  const dispatch = useStoreDispatch()

  const attrs = useMemo(() => {
    if (!isAvailable && IS_FIREFOX) {
      return {
        state: CONTROL_OFF,
        status: 'Try reloading the page',
        isDisabled: true,
      }
    }

    switch (shareScreenState) {
      case 'active':
        return {
          state: CONTROL_ON,
          status: 'On',
        }

      case 'progress':
        return {
          state: CONTROL_ON,
          status: 'On',
          isDisabled: true,
          isProgress: true,
        }

      case 'idle':
        return {
          state: CONTROL_OFF,
          status: 'Off',
        }
    }

  }, [isAvailable, shareScreenState])

  const handleClick = useCallback(() => {
    if (shareScreenState === 'idle') {
      if (!streamId) {
        return
      }
      const stream = createStream({
        streamID: streamId,
        video: false,
        audio: false,
        screen: true,
        ...(IS_FIREFOX ? { mediaSource: 'window' } : {}),
      })

      // { msg: "This browser does not support screen sharing" }
      // { msg: "This browser does not support screen sharing" }
      // { msg: "NotAllowedError" }
      try {
        stream.init(() => {
          dispatch(new AgoraScreenShareAction({ stream }))
        }, (error) => {

          if (error?.msg === 'NotAllowedError') {
            return
          }

          dispatch(new AgoraScreenShareUnavailableAction())
        })

      } catch (err) {
      }
    }

    if (shareScreenState === 'active') {
      dispatch(new AgoraStopScreenShareAction())
    }
  }, [dispatch, shareScreenState, streamId])

  return (
    <StreamControlPreset
      { ...attrs }
      isFullScreen={ isFullScreen }
      offIconSlug='screen'
      onIconSlug='screen'
      onClick={ handleClick }
    >
      <a onClick={ handleClick }>Screen Share</a>
    </StreamControlPreset>
  )
}


